import {Component, OnInit} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {HorarioNavBarComponent} from "./horario-nav-bar/horario-nav-bar.component";
import {ActivatedRoute, RouterLink, RouterLinkActive} from "@angular/router";
import {Apollo} from "apollo-angular";
import {getEspecialidadesNavBar, getEspecialidadesNavBarMongo, getServicesNavBar} from "../../graphql/graphql.queris";

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [
    NgOptimizedImage,
    HorarioNavBarComponent,
    NgClass,
    RouterLink,
    NgIf,
    NgForOf,
    RouterLinkActive
  ],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css'
})
export class NavBarComponent implements OnInit{

  data: any[] = [];
  especialidades: any[] = [];
  // servicios: any[] = [];
  loading = true;
  error: any;

  constructor(
    private route: ActivatedRoute,
    private apollo: Apollo
  ) {
  }



  ngOnInit():void {

    /*this.getEspecialidadesNavBar();
    this.apollo
      .watchQuery({
        query: getServicesNavBar
      })
      .valueChanges.subscribe((result: any) => {
      this.servicios = result?.data?.getAllServiciosProcedimientos;
      this.loading = result.loading;
      this.error = result.error;
    })*/
  }


  getEspecialidadesNavBar(): void {
  this.apollo.query({
    query: getEspecialidadesNavBarMongo
  }).subscribe((result: any) => {
    this.especialidades = result?.data?.getAllEspecialidadesMongo;
    // this.loading = result.loading;
    // this.error = result.error;
  }, (error) => {
    console.error('Error al obtener los datos de las especialidades', error);
  });
}





/*convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }*/



}
